import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../../actions/arts";
import {
    getNotificationCategories,
    getNotificationMessages,
    sendNotificationEmails,
} from "../../../../actions/notificaciones";
import { clearAllProviders, getAllProviders } from "../../../../actions/providers";
import snackbarUtils from "../../../../utils/snackbarUtils";
import NotificacionNuevoForm from "./notificacionNuevoForm";

const ALL_ART = "ALL";
const OTHER_MESSAGE = "OTHER";

const initialValues = {
    selectedArt: ALL_ART,
    selectedProviders: [],
    selectedCategory: "",
    selectedMessage: "",
    description: "",
};

const NotificacionNuevoContainer = () => {
    const dispatch = useDispatch();

    const arts = useSelector((state) => state.arts.list);
    const providers = useSelector((state) => state.providers.allProvidersOptions.data || []);
    const isProvidersLoading = useSelector((state) => state.providers.allProvidersOptions.isFetching);
    const notifications = useSelector((state) => state.notificaciones.list);
    const categories = useSelector((state) => state.notificaciones.categories);

    useEffect(() => {
        dispatch(getArts());
        dispatch(getNotificationCategories());
    }, []);

    const availableMessages = useMemo(() => {
        const result = notifications.map((message) => ({
            value: message.id,
            nombre: message.nombre,
            descripcion: message.descripcion,
        }));

        return [...result, { value: OTHER_MESSAGE, nombre: "Otros", descripcion: "" }];
    }, [notifications]);

    const availableArts = useMemo(
        () => arts.filter((art) => Number(art.permiteNotificacion) === 1),
        [arts],
    );

    const hasEnabledArts = availableArts.length > 0;

    const handleArtChange = (value) => {
        if (value !== ALL_ART && (value === undefined || value === null || value === "")) {
            return;
        }

        if (value === ALL_ART) {
            dispatch(clearAllProviders());
            return;
        }

        dispatch(getAllProviders(value));
    };

    const handleCategoryChange = (value) => {
        if (typeof value !== "string" || value.trim() === "") {
            return;
        }

        dispatch(getNotificationMessages(value));
    };

    const handleSend = async (values) => {
        const currentArt = values?.selectedArt;
        const currentProviders = values?.selectedProviders ?? [];
        const currentCategory = values?.selectedCategory;
        const currentDescription = values?.description ?? "";
        const currentMessage = notifications.find((message) => message.id === Number(values?.selectedMessage));

        const payload = {
            idArt: currentArt === ALL_ART ? null : Number(currentArt),
            idPrestadores: currentArt === ALL_ART ? [] : currentProviders.map((id) => Number(id)),
            titulo: currentMessage?.nombre || "Otros",
            tipoGestion: currentCategory,
            descripcion: currentDescription,
        };

        try {
            await dispatch(sendNotificationEmails(payload));
            snackbarUtils.success("Notificacion enviada correctamente.");
        } catch (error) {
        }
    };

    return (
        <NotificacionNuevoForm
            allArtValue={ALL_ART}
            initialValues={initialValues}
            availableArts={availableArts}
            availableMessages={availableMessages}
            providers={providers}
            isProvidersLoading={isProvidersLoading}
            categories={categories}
            hasEnabledArts={hasEnabledArts}
            onArtChange={handleArtChange}
            onCategoryChange={handleCategoryChange}
            onSend={handleSend}
        />
    );
};

export default NotificacionNuevoContainer;
